export default __webpack_public_path__ + "9ba58daf721045264794d2b2c2d036a5.svg";